import React, { useState } from 'react';

// Toplu geçici şifre atama sonucunu gösterir. Şifre yalnızca bu yanıtta bir kez
// döndüğü için kapatılmadan önce kopyalanması gerektiği vurgulanır.
const TempPasswordModal = ({ result, onClose }) => {
  const [copied, setCopied] = useState(false);
  if (!result) return null;

  const { temporaryPassword, affectedCount, skipped = [] } = result;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(temporaryPassword);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h3 style={styles.title}>Geçici Şifre Atandı</h3>
        <p style={styles.desc}>
          <strong>{affectedCount}</strong> kullanıcıya aşağıdaki ortak geçici şifre atandı.
          Bu şifre yalnızca bir kez gösterilir — <strong>kapatmadan önce kopyalayın</strong>.
          Kullanıcılar ilk girişte kendi şifrelerini belirleyecek.
        </p>

        <div style={styles.passwordRow}>
          <code style={styles.password}>{temporaryPassword}</code>
          <button style={styles.copyButton} onClick={handleCopy}>
            {copied ? '✓ Kopyalandı' : 'Kopyala'}
          </button>
        </div>

        {skipped.length > 0 && (
          <p style={styles.skipped}>
            {skipped.length} kullanıcı atlandı (zaten giriş yapmış veya uygun değil).
          </p>
        )}

        <button style={styles.closeButton} onClick={onClose}>Kapat</button>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
    justifyContent: 'center', alignItems: 'center', zIndex: 1000,
  },
  modal: {
    backgroundColor: 'white', padding: '28px', borderRadius: '8px',
    width: '440px', maxWidth: '90%', boxShadow: '0 4px 24px rgba(0,0,0,0.2)',
  },
  title: { margin: '0 0 12px', color: '#1a1a2e', fontSize: '18px' },
  desc: { fontSize: '13px', color: '#555', lineHeight: '1.6', marginBottom: '18px' },
  passwordRow: {
    display: 'flex', gap: '8px', alignItems: 'stretch', marginBottom: '12px',
  },
  password: {
    flex: 1, padding: '12px', backgroundColor: '#f3f4f6', borderRadius: '4px',
    fontSize: '18px', fontFamily: 'monospace', letterSpacing: '1px',
    color: '#111', wordBreak: 'break-all', display: 'flex', alignItems: 'center',
  },
  copyButton: {
    padding: '0 16px', backgroundColor: '#1a1a2e', color: 'white', border: 'none',
    borderRadius: '4px', fontSize: '13px', cursor: 'pointer', whiteSpace: 'nowrap',
  },
  skipped: { fontSize: '12px', color: '#92400e', marginBottom: '12px' },
  closeButton: {
    width: '100%', padding: '11px', backgroundColor: '#e5e7eb', color: '#1a1a2e',
    border: 'none', borderRadius: '4px', fontSize: '14px', cursor: 'pointer', marginTop: '4px',
  },
};

export default TempPasswordModal;
